export default {
  development: {
    BASE_HOST: 'https://oa-test.gongji58.com'
  },
  production: {
    BASE_HOST: 'https://oa.gongji58.com'
  },
  test: {
    BASE_HOST: 'https://oa-test.gongji58.com'
  }
};
